import React from 'react'
import { compact, reduce, uniq } from 'lodash'
import styled from 'styled-components';

import { __ } from '~/i18n'
import Link from '~/components/link'

import logic from './logic'

const LoggedInContainer = styled.div``;
const LogoutContainer = styled.span`
  display: inline-block;
  margin-left: 15px;
`;

@logic
export default class LoggedIn extends React.PureComponent {
  static defaultProps = {
    showLogout: false
  };

  render() {
    const { loggedIn, userInfo, showLogout } = this.props;
    const { logout } = this.props.actions;

    if (loggedIn && userInfo) {
      let loggedInAs = reduce(uniq(compact([
        userInfo.name,
        userInfo.email
      ])), (sum, itm) => {
        if (sum) {
          sum += ` (${itm})`;
        } else {
          sum += itm;
        }

        return sum;
      }, '');

      return (
        <LoggedInContainer>
          {loggedInAs ?
            <span>
            {__('You are logged in as')}
              {' '}
              <strong>{loggedInAs}</strong>
          </span>
            :
            __('You are logged in')
          }
          { showLogout ?
            <LogoutContainer>
              <Link href="#" onClick={ (e) => {
                e.preventDefault();
                logout();
              }}>{ __('Log Out') }</Link>
            </LogoutContainer>
            : null
          }
        </LoggedInContainer>
      )
    }
    return null;
  }
}